
































import {
  computed,
  ComputedRef,
  defineComponent,
  useContext,
} from '@nuxtjs/composition-api';

enum BackgroundColor {
  LightGray = 'bg-zinc-100',
  White = 'bg-white',
}

export default defineComponent({
  name: 'HeadlineText',
  props: {
    headline: { type: String, default: () => {} },
    text: { type: String, default: () => {} },
    backgroundColor: { type: String, default: BackgroundColor.LightGray },
  },
  setup(props) {
    const { $config } = useContext();

    // fix for images in rich text - BK-388
    const formattedText: ComputedRef<string> = computed(() => {
      const magentoBaseUrl = $config?.magentoBaseUrl;
      const text = props.text?.replace('{{media url=&quot;.renditions/', `${magentoBaseUrl}/media/`);
      return text?.replace('&quot;}}', '');
    });

    return {
      formattedText,
    };
  },
});
